import {P} from '@modifi/ui'
import styled from 'styled-components'

export const StyledP = styled(P)`
  text-align: center;
`
